import {SectionItem} from 'common/components/items-menu/types';

export enum FrequencyViewType {
  ConversionRate = `ConversionRate`,
  Conversion = `Conversion`,
  Dropoff = `Dropoff`,
}

export const FrequencyViewTypeDisplayName: {[key in FrequencyViewType]: Partial<SectionItem>} = {
  [FrequencyViewType.ConversionRate]: {
    label: `Conversion Rate`,
  },
  [FrequencyViewType.Conversion]: {
    label: `Conversion Count`,
  },
  [FrequencyViewType.Dropoff]: {
    label: `Dropoff Count`,
  },
};
